import { render, staticRenderFns } from "./Pruebas.vue?vue&type=template&id=88aee9b8"
import script from "./Pruebas.vue?vue&type=script&lang=js"
export * from "./Pruebas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports